import { mutate } from "swr";

import * as fetcher from "../fetcher";
import { type NewInstalledWidget } from "./types";
import { type WidgetData } from "./types";

export const updateWidgetPreferences = (
  widgetData: NewInstalledWidget | WidgetData,
  noMutate?: boolean
) => {
  return fetcher.core
    .post<WidgetData, false>(`/coworkers/widgetpreferences`, widgetData)
    .then((res) => {
      if (!noMutate) {
        mutate("/coworkers/widgetpreferences");
      }
      return res;
    });
};

export const deleteWidgetPreferences = (workspacePreferenceId: number) => {
  return fetcher.core
    .remove(`/coworkers/widgetpreferences/${workspacePreferenceId}`)
    .then((res) => {
      mutate("/coworkers/widgetpreferences");
      return res;
    });
};
